module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAbCAYAAAAULC3gAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAwSURBVHgB7dWhAQAgDMTAlv13BnRN7Yu7CeLS96sgp8LEBQEwtJctvAwgnZdt4oIe+p8MBGl3GP8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/menu.png
// module id = 216
// module chunks = 0 1 2